import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import {
  uploadFileFailed, uploadFileSuccessful, uploadSignFileFailed, uploadSignFileSuccessful,
} from '../actions';

export default function* uploadSignFile(action) {
  try {
    const formData = action.payload;
    const url = `${BACKEND_URL}/resources/documents/upload-signed-file`;
    const headers = {
      Accept: 'multipart/form-data',
      'Content-Type': 'multipart/form-data',
    };

    const dataResponse = yield makeRequest(url, formData, action, 'POST', true, headers, true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK || dataResponse.status === CREATED) {
      yield put(uploadFileSuccessful(data));
      yield put(uploadSignFileSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(uploadFileFailed(data));
      yield put(uploadSignFileFailed(data));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(uploadFileFailed());
    yield put(uploadSignFileFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
